import axios from 'axios';
import history from "../Components/history";
import { ToastContainer, toast } from 'react-toastify';

const apiClient = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json'
    },
});

// Add JWT token to HTTP requests
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


let isTokenExpiredToastVisible = false;
let isTokenExpiredToastLocked = false;
let isErrorToastVisible = false;
let isErrorToastLocked = false;


// Interceptor to handle responses
apiClient.interceptors.response.use(
    response => {
        isTokenExpiredToastVisible = false;
        return response;
    },
    error => {
        handleErrorResponse(error);
        return Promise.reject(error);
    }
);

const handleTokenExpiredToast = () => {
    if (isTokenExpiredToastLocked) return;
    isTokenExpiredToastLocked = true;

    if (!isTokenExpiredToastVisible) {
      isTokenExpiredToastVisible = true;
      toast.error('Your token has expired, please log in again.', {
        toastId: '401-error',
        onClose: () => {
          isTokenExpiredToastVisible = false;
          isTokenExpiredToastLocked = false; 
          history.push("/login");
        }
      });
      localStorage.removeItem('token');
      setTimeout(() => {
        isTokenExpiredToastVisible = false;
      }, 5000);
    } else {
        isTokenExpiredToastLocked = false;
    }
  };

  const handleErrorToast = (message) => {
    if (isErrorToastLocked) return;
    isErrorToastLocked = true;

    if (!isErrorToastVisible) {
        isErrorToastVisible = true;
      toast.error(message, {
        toastId: 'other-error',
        onClose: () => {
            isErrorToastVisible = false;
            isErrorToastLocked = false; 
        }
      });
      setTimeout(() => {
        isErrorToastVisible = false;
      }, 5000);
    } else {
        isErrorToastLocked = false;
    }
  };

// Centralized utility function to handle errors
export const handleErrorResponse = (error) => {
    const defaultMessage = 'An error occurred while processing your request.';
    const customMessage = error.config?.customErrorMessage || defaultMessage;

    if (!error) {
        toast.error(defaultMessage);
        return;
    }
    if (error.message && error.message === 'Unauthorized') {
        handleTokenExpiredToast();
        return new Promise(() => { });
    }
    else if (error.response) {
        const statusCode = error.response.status;
        if (statusCode === 401) {
                handleTokenExpiredToast();
                return new Promise(() => { }); 
        } else {
            handleErrorToast(customMessage);
        }
    } else {
        handleErrorToast('Network error. Please check your connection.');
        console.error('Network Error:', error.message);
    }
};


export default apiClient;